import { render, staticRenderFns } from "./edit-folder.vue?vue&type=template&id=1cc5d9dd&scoped=true&"
import script from "./edit-folder.vue?vue&type=script&lang=js&"
export * from "./edit-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc5d9dd",
  null
  
)

export default component.exports